import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        distanceToBottom: 0,
        versionType: 1
    },
    mutations: {
        setDistanceToBottom: (state, value) => {
            state.distanceToBottom = value
        },
        setVersionType: (state, value) => {
            state.versionType = value
        }
    },
    actions: {
        
    },
    getters: {

    },
    modules: {

    }
})
